import { Lang } from "../context/LocaleContext";

const txtTimeStampJustNow = {
  id: "Baru saja",
  en: "Just now",
};

const txtTimeStampOneMinuteAgo = {
  id: "1 menit yang lalu",
  en: "1 minute ago",
};

const txtTimeStampMinutesAgo = {
  id: "menit yang lalu",
  en: "minutes ago",
};

const txtTimeStampOneHourAgo = {
  id: "1 jam yang lalu",
  en: "1 hour ago",
};
const txtTimeStampHoursAgo = {
  id: "jam yang lalu",
  en: "hours ago",
};
const txtTimeStampOneDayAgo = {
  id: "1 hari yang lalu",
  en: "1 day ago",
};
const txtTimeStampDaysAgo = {
  id: "hari yang lalu",
  en: "days ago",
};

export const formatTimestamp = (timestamp: Date, lang: Lang): string => {
  const current_time = new Date();
  const time_difference = current_time.getTime() - timestamp.getTime();

  // Calculate the time difference in minutes
  const minutes = Math.floor(time_difference / (1000 * 60));

  // Handle different time ranges
  if (minutes < 1) {
    return txtTimeStampJustNow[lang];
  } else if (minutes === 1) {
    return txtTimeStampOneMinuteAgo[lang];
  } else if (minutes < 60) {
    return `${minutes} ${txtTimeStampMinutesAgo[lang]}`;
  } else if (minutes < 120) {
    return txtTimeStampOneHourAgo[lang];
  } else if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);
    return `${hours} ${txtTimeStampHoursAgo[lang]}`;
  } else if (minutes < 2880) {
    return txtTimeStampOneDayAgo[lang];
  } else {
    const days = Math.floor(minutes / 1440);
    return `${days} ${txtTimeStampDaysAgo[lang]}`;
  }
};
